import React from "react";
import "../../../../css/Common/Components/Cards/CardReview1.css";
import "../../../../css/App.css";

/**
 * CardReview1 is a React component that displays a review card with an image, review text, and reviewer name.
 * The card can be clicked to toggle a "clicked" state, which applies a CSS class for visual feedback.
 *
 * Props:
 * @param {Object} props - The component props.
 * @param {string} props.name - The name of the reviewer.
 * @param {string} props.image - The URL of the reviewer's image.
 * @param {number} [props.rating] - The rating given by the reviewer (optional, not currently displayed).
 * @param {string} props.text - The review text content.
 * @param {string} props.altText - The alt text for the reviewer's image.
 *
 * State:
 * @property {boolean} clicked - Indicates whether the card has been clicked.
 *
 * Example usage:
 * <CardReview1
 *   name="Jane Doe"
 *   image="/images/jane.jpg"
 *   rating={5}
 *   text="Great product!"
 *   altText="Jane Doe"
 * />
 */
class CardReview1 extends React.Component {
  constructor() {
    super();

    this.state = {
      clicked: false,
    };
  }

  render() {
    const { name, image, rating, text, altText } = this.props;
    return (
      <>
        <div
          className={`Card-Review1 ${this.state.clicked ? "clicked" : ""}`}
          onClick={() => this.setState({ clicked: !this.state.clicked })}
        >
          <img loading="eager" fetchPriority="high" src={image} alt={altText} />
          <div className="Content">{text}</div>
          <div className="Label-Large-Bold">{name}</div>
        </div>
      </>
    );
  }
}

export default CardReview1;
